import { useContext } from 'react';
import { OmniChatContext, OmniChatContextProps } from './OmniChatProvider';

export const useOmniChatContext = (): OmniChatContextProps => {
  const context = useContext(OmniChatContext);
  if (!context) {
    throw new Error('useOmniChatContext must be used within a CustomerChatContext');
  }
  return context;
};
